export default __webpack_public_path__ + "static/media/telegram.b56490a8.svg";